// extracted by mini-css-extract-plugin
module.exports = {"header_sale_types_popup":"saleTypesSettings_header_sale_types_popup__3DB77","close_icon":"saleTypesSettings_close_icon__OoXrt"};